/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

export default {
  documents: {
    documents: {
      actions: {
        add: true
      }
    }
  }
};
